"use client"

import { motion, AnimatePresence } from "framer-motion"
import { WifiOff, Loader2 } from "lucide-react"
import { useSocket } from "@/hooks/use-socket"

export default function ConnectionStatus() {
  const { connectionStatus, isSupported } = useSocket()

  // Não mostrar se WebSocket não for suportado
  if (!isSupported) return null

  // Só mostrar quando estiver conectando (não mostrar para disconnected)
  if (connectionStatus === "connected" || connectionStatus === "disconnected") return null

  const getStatusConfig = () => {
    switch (connectionStatus) {
      case "connecting":
        return {
          icon: Loader2,
          color: "text-blue-600",
          bgColor: "bg-blue-50",
          borderColor: "border-blue-200",
          message: "Conectando atualizações em tempo real...",
          animate: true,
        }
      case "closing":
        return {
          icon: WifiOff,
          color: "text-orange-600",
          bgColor: "bg-orange-50",
          borderColor: "border-orange-200",
          message: "Desconectando...",
          animate: false,
        }
      default:
        return null
    }
  }

  const config = getStatusConfig()
  if (!config) return null

  const StatusIcon = config.icon

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className={`fixed top-20 left-1/2 transform -translate-x-1/2 z-20 px-3 py-2 rounded-full shadow-lg border ${config.bgColor} ${config.borderColor}`}
      >
        <div className="flex items-center gap-2 text-sm">
          <StatusIcon className={`w-4 h-4 ${config.color} ${config.animate ? "animate-spin" : ""}`} />
          <span className={config.color}>{config.message}</span>
        </div>
      </motion.div>
    </AnimatePresence>
  )
}
